'use client'

import { createTRPCReact } from '@trpc/react-query'
import type { AppRouter } from '@vizible/api'

type TRPCReactClient = ReturnType<typeof createTRPCReact<AppRouter>>

export const trpcReact: TRPCReactClient = createTRPCReact<AppRouter>()

export async function isAuthed(getToken: () => Promise<string | null>) {
    try {
        const token = await getToken()
        return !!token
    } catch {
        return false
    }
}
